var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountSettingsIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 28.0002C28.488 28.0002 32.6667 23.8215 32.6667 18.6668C32.6667 13.5122 28.488 9.3335 23.3333 9.3335C18.1787 9.3335 14 13.5122 14 18.6668C14 23.8215 18.1787 28.0002 23.3333 28.0002Z",
    fill: "url(#paint0_linear_207_3220)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8966 30.3798C24.3833 30.3565 23.87 30.3332 23.3333 30.3332C17.6866 30.3332 12.4133 31.8965 7.90996 34.5798C5.85663 35.7932 4.66663 38.0798 4.66663 40.4832V46.6665H26.2733C24.6252 44.3155 23.6296 41.5698 23.3878 38.7089C23.146 35.848 23.6666 32.9741 24.8966 30.3798ZM48.4166 37.3332C48.4166 36.8198 48.3466 36.3532 48.2766 35.8632L50.9366 33.5065L48.6033 29.4698L45.22 30.6132C44.4733 29.9832 43.6333 29.4932 42.7 29.1432L42 25.6665H37.3333L36.6333 29.1432C35.7 29.4932 34.86 29.9832 34.1133 30.6132L30.73 29.4698L28.3966 33.5065L31.0566 35.8632C30.9866 36.3532 30.9166 36.8198 30.9166 37.3332C30.9166 37.8465 30.9866 38.3132 31.0566 38.8032L28.3966 41.1598L30.73 45.1965L34.1133 44.0532C34.86 44.6832 35.7 45.1732 36.6333 45.5232L37.3333 48.9998H42L42.7 45.5232C43.6333 45.1732 44.4733 44.6832 45.22 44.0532L48.6033 45.1965L50.9366 41.1598L48.2766 38.8032C48.3466 38.3132 48.4166 37.8465 48.4166 37.3332ZM39.6666 41.9998C37.1 41.9998 35 39.8998 35 37.3332C35 34.7665 37.1 32.6665 39.6666 32.6665C42.2333 32.6665 44.3333 34.7665 44.3333 37.3332C44.3333 39.8998 42.2333 41.9998 39.6666 41.9998Z",
    fill: "url(#paint1_linear_207_3220)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_207_3220",
    x1: 23.3333,
    y1: 9.3335,
    x2: 23.3333,
    y2: 28.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_207_3220",
    x1: 27.8016,
    y1: 25.6665,
    x2: 27.8016,
    y2: 48.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSettingsIconGreen);
export default __webpack_public_path__ + "static/media/account-settings-icon-green.561ec4259af7e22b58f74896bb10b044.svg";
export { ForwardRef as ReactComponent };